import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomCollectionsComponent } from './custom-collections.component';
import {CustomCmsItemModule} from '../custom-cms-item/custom-cms-item.module';
import {CmsConfig, ConfigModule, UrlModule} from '@spartacus/core';
import {MediaModule} from '@spartacus/storefront';
import {RouterModule} from '@angular/router';
import {CustomCarouselModule} from '../../../../spartacus/custom/shared/components/custom-carousel/custom-carousel.module';


@NgModule({
  declarations: [CustomCollectionsComponent],
  exports: [CustomCollectionsComponent],
  imports: [
    CommonModule,
    CustomCmsItemModule,
    CommonModule, MediaModule, RouterModule, UrlModule,
    CustomCarouselModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CollectionsComponent: {
          component: CustomCollectionsComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomCollectionsModule { }
